import React, { useState, useEffect } from "react";
import more from "../../assets/more.svg";
import collapse from "../../assets/collapse.svg";
import { useDispatch, useSelector } from "react-redux";
import { updateLevel3, updateLevel6 } from "../../store/QuestionnaireSlice";
import editPen from "../../assets/edit_pen.svg";
import trash from "../../assets/trash.svg";
import expand from "../../assets/expand.svg";
import check from "../../assets/check.png";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";
import { useRef } from "react";

const Level6 = forwardRef(
  ({ onNext, onBack, placement, editError, setEditError }, ref) => {
    const dispatch = useDispatch();
    const functionalDepartments = useSelector(
      (state) => state.questionnaire.level6Data
    );
    // console.log(functionalDepartments);
    const functions = useSelector((state) => state.questionnaire.level3Data);
    const departmentInputRef = useRef({});

    const [activeDropdown, setActiveDropdown] = useState(null);
    const [newDepartmentName, setNewDepartmentName] = useState({});
    const [isAddingDepartment, setIsAddingDepartment] = useState({});
    const [editFunctionIndex, setEditFunctionIndex] = useState(null);
    const [editFunctionName, setEditFunctionName] = useState("");
    const [showDepartment, setShowDepartment] = useState([]);
    const [editingDepartment, setEditingDepartment] = useState(null); // For department editing
    const [editedDepartmentName, setEditedDepartmentName] = useState("");
    const [error, setError] = useState("");
    const questions = useSelector((state) => state.questionnaire.questions);

    useImperativeHandle(ref, () => ({
      handleNext,
    }));

    useEffect(() => {
      if (
        functions.length > 0 &&
        Object.keys(functionalDepartments).length < functions.length
      ) {
        const initialState = functions.reduce((acc, func) => {
          if (functionalDepartments[func.name]) {
            acc[func.name] = functionalDepartments[func.name];
          } else {
            acc[func.name] = [];
          }
          return acc;
        }, {});
        // console.log(initialState);
        dispatch(updateLevel6(initialState));
      }
    }, [functions]);

    const handleAddDepartmentClick = (functionName) => {
      setIsAddingDepartment({
        ...isAddingDepartment,
        [functionName]: true,
      });
      setNewDepartmentName({
        ...newDepartmentName,
        [functionName]: "",
      });

      setTimeout(() => {
        if (departmentInputRef.current[functionName]) {
          departmentInputRef.current[functionName].focus();
        }
      }, 0);
    };

    const handleAddDepartment = (functionName) => {
      if (!newDepartmentName[functionName]?.trim()) return;

      const departments = functionalDepartments[functionName] || [];
      const updatedDepartments = {
        ...functionalDepartments,
        [functionName]: [
          ...departments,
          { _id: "", name: newDepartmentName[functionName] },
        ],
      };
      dispatch(updateLevel6(updatedDepartments));

      // Reset the input state
      setIsAddingDepartment({
        ...isAddingDepartment,
        [functionName]: false,
      });
      setNewDepartmentName({
        ...newDepartmentName,
        [functionName]: "",
      });
    };

    const handleDeleteDepartment = (functionName, index) => {
      const updatedDepartments = {
        ...functionalDepartments,
        [functionName]: functionalDepartments[functionName].filter(
          (_, i) => i !== index
        ),
      };
      dispatch(updateLevel6(updatedDepartments));
      setActiveDropdown(null);
    };

    const handleEditFunction = (index, currentName) => {
      setEditFunctionIndex(index);
      setEditFunctionName(currentName);
      setActiveDropdown(null);
    };
    const handleSaveFunction = (index) => {
      // const updatedFunctions = functions.map((func, i) =>
      //   i === index ? editFunctionName : func
      // );
      if (editFunctionName.trim()) {
        const updatedFunctions = [...functions];
        let updatedFunctionalDepartment = functionalDepartments;

        updatedFunctionalDepartment = {
          ...updatedFunctionalDepartment,
          [editFunctionName]:
            updatedFunctionalDepartment[updatedFunctions[index].name],
        };
        if (editFunctionName !== updatedFunctions[index].name) {
          delete updatedFunctionalDepartment[updatedFunctions[index].name];
        }
        // console.log(updatedFunctionalDepartment);

        updatedFunctions[index] = {
          ...updatedFunctions[index],
          name: editFunctionName,
        };
        dispatch(updateLevel6(updatedFunctionalDepartment));
        dispatch(updateLevel3(updatedFunctions)); // Update the functions in the Redux store
        setEditFunctionIndex(null);
        setEditFunctionName("");
      } else {
        setError("Function title cannot be empty");
        setEditFunctionIndex(null);
        return "Function title cannot be empty";
      }
    };

    const handleEditDepartment = (functionName, index, currentName) => {
      setEditingDepartment({ functionName, index });
      setEditedDepartmentName(currentName);
      setActiveDropdown(null);
    };

    const handleSaveDepartment = () => {
      if (editedDepartmentName.trim()) {
        const { functionName, index } = editingDepartment;
        const updatedDepartments = {
          ...functionalDepartments,
          [functionName]: functionalDepartments[functionName].map((dept, i) =>
            i === index ? { ...dept, name: editedDepartmentName } : dept
          ),
        };
        dispatch(updateLevel6(updatedDepartments));

        setEditingDepartment(null);
        setEditedDepartmentName("");
      } else {
        setError("Department title cannot be empty");
        setEditingDepartment(null);
        return "Department title cannot be empty";
      }
    };

    // useEffect(() => {
    //   console.log("updated functional department ->< ", functionalDepartments);
    // }, []);

    const handleDeleteFunction = (index) => {
      const updatedFunctions = functions.filter((_, i) => i !== index);
      let updatedFunctionalDepartment = { ...functionalDepartments };
      delete updatedFunctionalDepartment[functions[index].name];
      dispatch(updateLevel6(updatedFunctionalDepartment));
      dispatch(updateLevel3(updatedFunctions)); // Remove the function from Redux
      setActiveDropdown(null);
    };

    const handleNext = () => {
      const updatedDepartments = { ...functionalDepartments };

      for (const functionName in newDepartmentName) {
        if (newDepartmentName[functionName]) {
          const departments = updatedDepartments[functionName] || [];
          updatedDepartments[functionName] = [
            ...departments,
            { _id: "", name: newDepartmentName[functionName] },
          ];
        }
      }
      // console.log("updated department -> ", updatedDepartments);
      setNewDepartmentName({});

      // Dispatch the updated departments only once
      dispatch(updateLevel6(updatedDepartments));

      let isValid = true;
      for (const functionName in functionalDepartments) {
        if (
          (functionalDepartments[functionName] &&
            functionalDepartments[functionName].length > 0) ||
          newDepartmentName[functionName]
        ) {
          continue;
        } else {
          isValid = false;
          break;
        }
      }
      // const isValid = Object.keys(functionalDepartments).every(
      //   (functionName) =>
      //     functionalDepartments[functionName] &&
      //     functionalDepartments[functionName].length > 0
      // );

      if (functions.length === 0) {
        setError("Please add atleast one function at level 3");
        return "Please add atleast one function at level 3";
      }
      if (!isValid) {
        setError("Each function must have at least one department");
        return "Each function must have at least one department";
      }
      setError("");

      if (onNext) {
        onNext();
      }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = () => setActiveDropdown(null);
      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    return (
      <div>
        <div
          className={` pb-6 px-10 mx-auto rounded-lg max-w-[1200px] ${
            placement !== "edit" ? "bg-[#F4F5F6] pt-[30px]" : "bg-white"
          }`}
        >
          <div className="bg-[#1C3F3A] text-white px-[10px] py-[6px] w-fit rounded-md text-[12px]">
            Level 6
          </div>
          <p
            className={`mt-3 mb-6 font-medium ${
              placement === "edit" ? "text-[1.125rem]" : "text-[1.25rem]"
            }`}
          >
            {questions[5]?.description}
          </p>
          {(error || editError) && (
            <p className="flex justify-between items-center bg-red-100 border-l-2 border-0 mb-5 border-red-400 text-red-700 px-4 py-3">
              {error ? error : editError}
              <span
                className="cursor-pointer"
                onClick={() => {
                  if (editError) {
                    setEditError("");
                  } else {
                    setError("");
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 26 26"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </span>
            </p>
          )}
          <div className="space-y-3">
            {functions.map((functionName, functionIndex) => (
              <div
                key={functionIndex}
                className={`${
                  !showDepartment.includes(functionIndex)
                    ? "space-y-5 mb-6 mt-6"
                    : ""
                }`}
              >
                <div className="flex gap-3 items-center ">
                  <img
                    src={
                      !showDepartment.includes(functionIndex)
                        ? collapse
                        : expand
                    }
                    alt=""
                    onClick={() =>
                      setShowDepartment(
                        showDepartment.includes(functionIndex)
                          ? showDepartment.filter(
                              (index) => index !== functionIndex
                            )
                          : [...showDepartment, functionIndex]
                      )
                    }
                  />
                  {editFunctionIndex === functionIndex ? (
                    <div className="max-w-[210px]">
                      <input
                        type="text"
                        value={editFunctionName}
                        onChange={(e) => setEditFunctionName(e.target.value)}
                        onBlur={() => handleSaveFunction(functionIndex)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            handleSaveFunction(functionIndex);
                          }
                        }}
                        className="border border-gray-300 rounded-lg px-[0.75rem] py-[0.325rem] text-[15px] w-full outline-none"
                        autoFocus
                      />
                    </div>
                  ) : (
                    <div
                      className="flex items-center min-w-[214px] gap-3 justify-between px-[0.75rem] py-[0.325rem] bg-white rounded-lg shadow-sm border border-[#D9D9D9]"
                      onClick={() =>
                        handleEditFunction(functionIndex, functionName.name)
                      }
                    >
                      <span className="font-medium">{functionName.name}</span>
                      <div className="relative flex">
                        <button
                          className="flex justify-center"
                          onClick={(e) => {
                            e.stopPropagation();
                            // setActiveDropdown(
                            //   activeDropdown === functionIndex
                            //     ? null
                            //     : functionIndex
                            // );
                            handleDeleteFunction(functionIndex);
                          }}
                        >
                          <img src={trash} alt="" />
                        </button>
                        {/* {activeDropdown === functionIndex && (
                          <div className="absolute top-5 right-0 mt-2 w-32 bg-white rounded-md shadow-lg border border-gray-200 z-50">
                            <button
                              className="w-full px-4 py-2 text-left hover:bg-gray-100 text-sm border-b border-[#D9D9D9] flex items-center gap-2"
                              onClick={() =>
                                handleEditFunction(
                                  functionIndex,
                                  functionName.name
                                )
                              }
                            >
                              <img src={editPen} alt="" />
                              Edit
                            </button>
                            <button
                              className="w-full px-4 py-2 text-left hover:bg-gray-100 text-sm flex items-center gap-2"
                              onClick={() =>
                                handleDeleteFunction(functionIndex)
                              }
                            >
                              <img src={trash} alt="" />
                              Delete
                            </button>
                          </div>
                        )} */}
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex gap-3 relative pl-8">
                  {!showDepartment.includes(functionIndex) && (
                    <div className="">
                      <div className="border-l-[1.5px] border-b-[1.5px] border-black w-[13.5px] h-[40.5px] absolute left-[9px] -top-[23px]"></div>

                      <div className="flex flex-wrap gap-3">
                        {functionalDepartments[functionName.name]?.map(
                          (department, deptIndex) =>
                            editingDepartment &&
                            editingDepartment.functionName ===
                              functionName.name &&
                            editingDepartment.index === deptIndex ? (
                              <div className="max-w-[214px]">
                                <input
                                  type="text"
                                  value={editedDepartmentName}
                                  onChange={(e) =>
                                    setEditedDepartmentName(e.target.value)
                                  }
                                  onBlur={handleSaveDepartment}
                                  onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                      handleSaveDepartment();
                                    }
                                  }}
                                  className="px-[0.75rem] py-[0.325rem] w-full outline-none border border-[#1C3F3A] rounded-lg"
                                  autoFocus
                                />
                              </div>
                            ) : (
                              <div
                                key={deptIndex}
                                className="flex items-center gap-3 min-w-[214px] h-fit justify-between px-[0.75rem] py-[0.325rem] bg-white rounded-lg shadow-sm border border-[#D9D9D9]"
                                onClick={() =>
                                  handleEditDepartment(
                                    functionName.name,
                                    deptIndex,
                                    department.name
                                  )
                                }
                              >
                                <span className="font-medium">
                                  {department.name}
                                </span>
                                <div className="relative flex">
                                  <button
                                    className="flex justify-center"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteDepartment(
                                        functionName.name,
                                        deptIndex
                                      );
                                    }}
                                  >
                                    <img src={trash} alt="" />
                                  </button>
                                  {/* {activeDropdown ===
                                    `${functionName.name}-${deptIndex}` && (
                                    <div className="absolute top-5 right-0 mt-2 w-32 bg-white rounded-md shadow-lg border border-gray-200 z-50">
                                      <button
                                        className="w-full px-4 py-2 text-left hover:bg-gray-100 text-sm border-b border-[#D9D9D9] flex items-center gap-2"
                                        onClick={() =>
                                          handleEditDepartment(
                                            functionName.name,
                                            deptIndex,
                                            department.name
                                          )
                                        }
                                      >
                                        <img src={editPen} alt="" />
                                        Edit
                                      </button>
                                      <button
                                        className="w-full px-4 py-2 text-left hover:bg-gray-100 text-sm flex items-center gap-2"
                                        onClick={() =>
                                          handleDeleteDepartment(
                                            functionName.name,
                                            deptIndex
                                          )
                                        }
                                      >
                                        <img src={trash} alt="" className="" />
                                        Delete
                                      </button>
                                    </div>
                                  )} */}
                                </div>
                              </div>
                            )
                        )}
                        {/* {isAddingDepartment[functionName.name] ? ( */}
                        <div className="flex gap-2 w-[214px]">
                          <div className="relative w-[210px]">
                            <input
                              ref={(el) =>
                                (departmentInputRef.current[functionName.name] =
                                  el)
                              }
                              type="text"
                              value={newDepartmentName[functionName.name] || ""}
                              onChange={(e) => {
                                // console.log(newDepartmentName);
                                setNewDepartmentName({
                                  ...newDepartmentName,
                                  [functionName.name]: e.target.value,
                                });
                              }}
                              placeholder="Enter Department Title"
                              className="px-4 py-[0.325rem] w-full border border-[#D9D9D9] rounded-[6px] focus:outline-none placeholder-[#1C3F3A] placeholder-opacity-50"
                              onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                  handleAddDepartment(functionName.name);
                                }
                              }}
                            />
                            <img
                              src={check}
                              alt=""
                              className="absolute right-2 top-3 max-sm:hidden"
                            />
                          </div>
                          {/* <input
                             type="text"
                             value={newDepartmentName[functionName.name] || ""}
                             onChange={(e) =>
                               setNewDepartmentName({
                                 ...newDepartmentName,
                                 [functionName.name]: e.target.value,
                               })
                             }
                             placeholder="Enter Department Name"
                             className="flex-1 px-3 py-2 border h-fit border-[#1C3F3A] rounded-md focus:outline-none focus:ring-1 focus:ring-[#1C3F3A]"
                             onKeyPress={(e) => {
                               if (e.key === "Enter") {
                                 handleAddDepartment(functionName.name);
                               }
                             }}
                           /> */}
                          {/* <button
                             onClick={() =>
                               handleAddDepartment(functionName.name)
                             }
                             className="px-4 py-2 h-fit bg-[#55C880] text-white rounded-md hover:bg-[#152e2b] transition-colors"
                           >
                             Add
                           </button> */}
                        </div>
                        <button
                          onClick={() => {
                            handleAddDepartmentClick(functionName.name);
                            handleAddDepartment(functionName.name);
                          }}
                          className="relative py-[0.375rem] h-fit w-[214px] font-medium rounded-[6px] text-[#1C3F3A] hover:bg-[#f0f0f0] transition-colors"
                        >
                          <svg
                            width="100%"
                            height="100%"
                            viewBox="0 0 210 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="absolute inset-0"
                            preserveAspectRatio="none"
                          >
                            <rect
                              x="0.5"
                              y="0.5"
                              width="99%"
                              height="97%"
                              rx="5.5"
                              fill="white"
                              stroke="#1C3F3A"
                              strokeWidth="1"
                              strokeDasharray="4 4"
                            />
                          </svg>
                          <span className="relative z-10">
                            Add New Department
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        {placement !== "edit" && (
          <div className="flex justify-between mt-[26px]">
            <button
              className="border border-[#D9D9D9] text-[#1C3F3A] flex gap-3 justify-center items-center py-[0.825rem] rounded-[10px] font-inter font-medium px-5 hover:bg-[#f0f0f0] transition-colors"
              onClick={onBack}
            >
              <svg
                width="17"
                height="8"
                viewBox="0 0 17 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.80775 0.192239L4.52125 0.899989L1.92125 3.49999H17V4.49999H1.92125L4.5155 7.09999L3.802 7.80774L0 3.99999L3.80775 0.192239Z"
                  fill="#1C3F3A"
                />
              </svg>
              Back
            </button>
            <button
              className="bg-[#55C880] flex items-center justify-center gap-3 text-white pl-5 pr-6 py-[0.825rem] rounded-[10px] overflow-hidden"
              onClick={handleNext}
            >
              Next
              <svg
                width="17"
                height="8"
                viewBox="0 0 17 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.1923 7.80776L12.4788 7.10001L15.0788 4.50001H0V3.50001H15.0788L12.4845 0.900011L13.198 0.192261L17 4.00001L13.1923 7.80776Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        )}
      </div>
    );
  }
);

export default Level6;
